import {httpClient} from '@/main';
import PlanModel, {DialogData} from '@/models/PlanModel';

export const fetchPlan = (pageIndex: number, rowCount: number) =>
    httpClient.get<PlanModel>('plan/getAll', {
        params: {
            pageIndex,
            rowCount,
        },
    });
export const fetchCreate = () => httpClient.get<DialogData>('plan/getCreate');
export const fetchSaveCreate = (data: DialogData) => httpClient.post<{[key: string]: any}>('plan/create', data.Item);
export const fetchDownload = (idPlan: number) =>
    httpClient.get(`solve/download`, {
        params: {
            idPlan,
        },
        responseType: 'blob',
    });
export const fetchDelete = (id: number, pageIndex: number, rowCount: number) =>
    httpClient.post('plan/delete', null, {
        params: {
            id,
            pageIndex,
            rowCount,
        },
    });

export const fetchDeleteAll = () => httpClient.post('plan/deleteAll');
